import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import ReactPlayer from "react-player";

export default function VideoPlayer({
    video,
    onModalDismiss,
}) {

    const [modalIsOpen, setModalIsOpen] = useState(!!video);

    useEffect(() => {
        setModalIsOpen(!!video);
    });

    const closeModal = () => {
        setModalIsOpen(false);
        onModalDismiss();
    };
    const customStyles = {
        overlay: {
            position: "fixed",
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            zIndex: 10000000,
        },
        content: {
            position: "absolute",
            backgroundColor: "rgba(255,255,255,0.0)",
            borderRadius: "20px",
            border: "none",
            margin: 0,
            padding: 0,
            left: "10%",
            right: "10%",
        },
    };
    if (!video?.link) {
        return <></>;
    }
    return (
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            style={customStyles}
            closeTimeoutMS={500}
        >
            <div className="d-flex" style={{ height: "100%" }}>
                <div style={{ flexGrow: 1 }}>
                    <ReactPlayer height="99%" width="99%" url={video.link} controls playsinline config={{
                        youtube: {
                            playerVars: { autoplay: 1 }
                        },
                        vimeo: {
                            playerVars: { autoplay: 1 }
                        }
                    }}
                    />
                </div>
            </div>
        </Modal>
    );
}
